import React, { Component } from 'react'
import styled from 'styled-components'
import { CommentsApi } from '../../API/api'
import reloadIcon from '../../static/images/icons/reload.png'
import CommentTopBar from './CommentsTopBar'

import CommentList from '../comments/CommentList'
import { GA_Event } from '../Analytics/Analytics'

const Container = styled.div`
margin-top: 40px;
font-size: 23px !important;
display: block;
max-width: 980px;
margin: 20px auto 40px;
display:${props => props.shown ? 'block' : 'none'};
`
const LoadCommentsContainer = styled.div`
text-align:center;
user-select:none;
transition:opacity 1s;
${props => {
        switch (props.state) {
            case 'loading':
                return `
            opacity:.4;
            `
            case 'off':
                return `
            display:none;
            `
            default:
                return '';
        }
    }}
`
const LoadButton = styled.button`
cursor:pointer;
> *{
    vertical-align:middle;
}
span{
    text-align:right;
    margin-right:20px;
    display:inline-block;
    font-size:16px;
    max-width:90px;
}
`
const LoadIcon = styled.div`
will-change:transform;
display:inline-block;
`
class Comments extends Component {
    constructor() {
        super();
    }
    
    render() {
        return (
            <Container shown={this.props.showContainer}>
                <div>
                    <CommentTopBar
                        commentCount={this.props.commentCount}
                        showCommentCount={true}   
                        articleRef={this.props.articleRef}
                    />
                </div>
                <div>
                    <CommentList
                        comments={this.props.comments}
                        articleRef={this.props.articleRef}
                    />
                </div>
                {this.props.showMoreCommentsState === "on" ?
                    <LoadCommentsContainer state={this.props.showMoreCommentsState}>
                        <LoadButton onClick={this.props.onLoadMoreClick}>
                            <LoadIcon>
                                <img src={reloadIcon} alt="" />
                            </LoadIcon>
                            <span>טען תגובות נוספות</span>
                        </LoadButton>
                    </LoadCommentsContainer>
                    : this.props.commentCount > 8 ?
                    <CommentTopBar
                        commentCount={this.props.commentCount}
                        showCommentCount={false}
                        articleRef={this.props.articleRef}
                    />
                    : ""
                }
            </Container>
        )
    }
}

export default Comments;


// WEBPACK FOOTER //
// ./src/Components/comments/Comments.jsx